<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi"></div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">往届精彩回顾</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">第21届（2022年+2023年）</el-menu-item>
            <el-menu-item index="2">第20届（2021年）</el-menu-item>
            <el-menu-item index="3">第19届（2020年）</el-menu-item>
            <el-menu-item index="4">第18届（2019年）</el-menu-item>
            <el-menu-item index="5">第17届（2018年）</el-menu-item>
            <el-menu-item index="6">第16届（2017年）</el-menu-item>
            <el-menu-item index="7">第14届（2015年）</el-menu-item>
            <el-menu-item index="8">第13届（2013年）</el-menu-item>
            <el-menu-item index="9">第12届（2011年）</el-menu-item>
            <el-menu-item index="10">第11届（2009年）</el-menu-item>
            <el-menu-item index="11">第10届（2007年）</el-menu-item>
            <el-menu-item index="12">第9届（2005年）</el-menu-item>
            <el-menu-item index="13">第8届（2003年）</el-menu-item>
            <el-menu-item index="14">第7届（2001年）</el-menu-item>
            <el-menu-item index="15">第6届（1999年）</el-menu-item>
            <el-menu-item index="16">第5届（1997年）</el-menu-item>
            <el-menu-item index="17">第4届（1995年）</el-menu-item>
            <el-menu-item index="18">第3届（1992年）</el-menu-item>
            <el-menu-item index="19">第2届（1989年）</el-menu-item>
            <el-menu-item index="20">第1届（1986年）</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>往届精彩回顾</div>
          </div>
          <div>
            <div class="demo-image__preview">
              <div style="font-size:32px; font-weight:700;">{{zhname}}</div>
              <el-tabs style="margin-left:20px;" v-model="activeName">
                <el-tab-pane label="展会图片" name="first">
                  <div style="text-align:center;margin:20px 0" v-if="this.url">
                    <el-image :src="url" :preview-src-list="srcList" style="width:80%;display:block;margin:0 auto">
                    </el-image>
                  </div>
                  <div style="font-size:24px; font-weight: 600;" v-else>暂无图片</div>
                </el-tab-pane>
                <el-tab-pane label="展会视频" name="second">
                  <div style="text-align:center;margin:20px 0" v-if="this.video!=[]">
                    <div v-for="(item,index) in this.video" :key="index">
                      <video width="80%" controls :src="item"></video>
                    </div>
                  </div>
                  <div style="font-size:24px; font-weight: 600;" v-else>暂无视频</div>
                </el-tab-pane>
              </el-tabs>

            </div>
          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   data: String,
  //   nametitle: String
  // },
  props: ['data2'],
  watch: {
    // 监听 data 的变化
    data2 (newValue, oldValue) {
      this.pageNum = newValue
      console.log(this.pageNum)
    }
  },
  name: 'Gyzh',
  data () {
    return {
      pageNum: '1',
      url: '',
      srcList: [
      ],
      list: [],
      zhname: '',
      activeName: 'first',
      video: ''
    }
  },
  beforeDestroy () {

  },
  destroyed () {

  },
  created () {
    this.list = {
      name: '第21届（2022年+2023年）',
      img: [],
      video: []
    }
    this.srcList = this.list.img
    this.url = this.list.img[0]
    this.zhname = this.list.name
  },
  mounted () {
    if (this.data2) {
      this.pageNum = this.data2
      this.handleSelect(this.data2)
    }
  },
  methods: {
    handleSelect (key) {
      this.pageNum = key
      this.activeName = 'first'
      window.translate.execute()
      if (this.pageNum === '1') {
        this.list = {
          name: '第21届（2022年+2023年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '2') {
        this.list = {
          name: '第20届（2021年）',
          img: ['https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902(4).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195901 (1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195901.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902 (1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902(1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902(1) (1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902(2).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902(3).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/20/20211101195902.jpg'],
          video: []
        }
      } else if (this.pageNum === '3') {
        this.list = {
          name: '第19届（2020年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '4') {
        this.list = {
          name: '第18届（2019年）',
          img: ['https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105449.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105435(2).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105432(1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105432.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105433(1).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105433(2).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105433(3).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105433.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105434(2).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105434(3).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105434(4).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105434.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105436.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105436(2).jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105435.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105703.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105831.jpg', 'https://www.ciepec-online.com/u/cms/www/xwy-images/his/18/20230913105901.jpg'],
          video: []
        }
      } else if (this.pageNum === '5') {
        this.list = {
          name: '第17届（2018年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '6') {
        this.list = {
          name: '第16届（2017年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '7') {
        this.list = {
          name: '第14届（2015年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '8') {
        this.list = {
          name: '第13届（2013年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '9') {
        this.list = {
          name: '第12届（2011年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '10') {
        this.list = {
          name: '第11届（2009年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '11') {
        this.list = {
          name: '第10届（2007年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '12') {
        this.list = {
          name: '第9届（2005年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '13') {
        this.list = {
          name: '第8届（2003年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '14') {
        this.list = {
          name: '第7届（2001年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '15') {
        this.list = {
          name: '第6届（1999年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '16') {
        this.list = {
          name: '第5届（1997年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '17') {
        this.list = {
          name: '第4届（1995年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '18') {
        this.list = {
          name: '第3届（1992年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '19') {
        this.list = {
          name: '第2届（1989年）',
          img: [],
          video: []
        }
      } else if (this.pageNum === '20') {
        this.list = {
          name: '第1届（1986年）',
          img: [],
          video: []
        }
      }
      if (this.list.img.length > 0) {
        this.srcList = this.list.img
        this.url = this.list.img[0]
      } else {
        this.srcList = []
        this.url = ''
      }
      if (this.list.video.length > 0) {
        this.video = this.list.video
      } else {
        this.video = ''
      }
      console.log(this.video)
      this.zhname = this.list.name
      this.$emit('childFn')
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: contain;
  height: 450px; /* 元素高度 */
  width: 80%;
  margin: 0 auto;
}

.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
/deep/.el-image-viewer__wrapper {
  position: absolute;
  width: 500px !important;
}
/deep/ .el-image-viewer__canvas {
  position: absolute;
  width: 500px !important;

  top: 10%;
}
/deep/ .el-image-viewer__prev {
  left: 200px !important;
}
.demo-image__preview {
  text-align: center;
  margin-top: 20px;
}
/deep/ .el-tabs__item {
  font-size: 20px !important;
  font-weight: 600;
  color: #4876b9;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/wjhg.vue